<template>
<div class="x_box A4">
    <div class="x_body">
        <div class="print-header font-m" style="display: flex; justify-content: space-between">
            <div>
                <img src="../../assets/company_logo.png" alt="">
            </div>
            <div>
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <h2 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h2>
                <div style="font-size: 13px;">
                    <b>{{$t('address')}}៖ </b>
                    {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
                </div>
                <div style="font-size: 13px;">
                    <b>{{$t('phone_contact')}}</b>
                    {{company.Phone}} <span>{{$t('email')}}</span>: {{company.Email}}
                    <br>
                    លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
                </div>
            </div>
        </div>
        <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('sale_quotation')}}</h3>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.CustomerName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('phone') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Phone}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('invoice_no')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>ទំនិញសេវាកម្ម</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">សរុប</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.TaxLine)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('untax_amount')}}:</th>
                                    <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('taxes')}}:</th>
                                    <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('total')}}:</th>
                                    <th class="text-right">{{$money(invoice.TotalAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                company: {},
                invoice: {},
                lines: []
            }
        },
        created: function(){
            this.getCompany();
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('sale/quote/preview', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.lines = data.Lines;
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
</style>
